module.exports = __webpack_public_path__ + "static/media/transcribe-IPhone.eb8e00c3.png";